export class DropDownConstantsFactory {
 public static createStandardClientDropdownSettings() {
   return {
    text: 'name',
    value: 'id'
  };
 }

  public static createEnumDropdownSettings() {
    return {
      text: 'value',
      value: 'key'
    };
  }

  public static createNumericEnumDropdownSettings() {
    return {
      text: 'text',
      value: 'value'
    };
  }
}

export interface StandardDropdownItem {
  name: string;
  id: number;
}

export interface NumericEnumDropdownItem {
  text: string;
  value: number;
}

export interface EnumDropdownItem {
  key: string;
  value: string;
}
